import React from "react";
import { Locale } from "@linkfluence/models/locale";
import { Fieldset, Label } from "@ui-kit/form";
import Input from "@ui-kit/form/text/index";
import { useCurrentProjectFocusesId } from "@radarly/core/project/use-cases";
import { useCurrentWorkspaceId } from "@radarly/core/workspace/use-cases";
import { tr } from "@radarly/i18n";
import { Card } from "@radarly/models/cards";
import { editPostIdOnCard } from "@radarly/models/cards/editor";
import { PinnedPostCard } from "@radarly/models/cards/model";

export interface SharedPanelsCardEditionSidebarPinnedPostProps {
  card: PinnedPostCard;
  setCard: (card: Card) => void;
  locale: Locale;
}

export default function SharedPanelsCardEditionSidebarPinnedPost({
  card,
  setCard,
  locale,
}: SharedPanelsCardEditionSidebarPinnedPostProps) {
  const workspaceId = useCurrentWorkspaceId();
  const projectFocuses = useCurrentProjectFocusesId();
  return (
    <>
      <Fieldset>
        <Label htmlFor="name">
          {tr(locale, "INSIGHT_PAGES::EDITOR::POST_ID")}
        </Label>
        <Input
          value={card.dataviz.postId}
          onChange={(postId) =>
            setCard(editPostIdOnCard(workspaceId, projectFocuses, card, postId))
          }
          placeholder={tr(locale, "INSIGHT_PAGES::EDITOR::POST_ID_PLACEHOLDER")}
        />
      </Fieldset>
    </>
  );
}
